import styled from 'styled-components';

export const Tab = styled.div`
  z-index: 998;
  background: white;
  margin-top: 50px;
  overflow-x: auto;
  border-bottom: 1px solid #e3e5ea;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-y: hidden;
  flex-direction: row;
  margin-left: -24px;
  margin-right: -24px;
  @media (min-width: 992px) {
    margin-top: 70px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .item {
    h5 {
      font-size: 1.1em;
    }
    flex: 0 0 auto;
    cursor: pointer;
    padding: 1em 0.7em;
    @media (min-width: 992px) {
      padding: 1em 1.5em;
    }
    color: #c7cad0;
    &:first-child {
      margin-left: 1em;
      @media (min-width: 992px) {
        margin-left: 0;
        padding-left: 0;
      }
    }
    &:last-child {
      margin-right: 1em;
    }
    &.active {
      cursor: inherit;
      color: black;
      h5 {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: -0.9em;
          border-bottom: 2px solid black;
          @media (min-width: 992px) {
            border-bottom: 3px solid black;
          }
          left: 0;
          right: 0;
        }
      }
    }
  }
`;

export const BlogTab = styled(Tab)`
  .item {
    h5 {
      font-size: 16px;
    }
    padding: 14px 12px;
    &.active {
      h5 {
        &::after {
          bottom: -14px;
        }
      }
    }
  }
`;

export const SmallTab = styled.div`
  z-index: 998;
  background: white;
  margin-top: 50px;
  overflow-x: auto;
  border-bottom: 1px solid #e3e5ea;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-y: hidden;
  flex-direction: row;
  margin-left: -24px;
  margin-right: -24px;
  @media (min-width: 992px) {
    margin-top: 70px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .item {
    h5 {
      font-size: 16px;
    }
    flex: 0 0 auto;
    cursor: pointer;
    padding: 1em 0.7em;
    color: #c7cad0;
    &:first-child {
      margin-left: 1em;
      @media (min-width: 992px) {
        margin-left: 0;
        padding-left: 0;
      }
    }
    &:last-child {
      margin-right: 1em;
    }
    &.active {
      cursor: inherit;
      color: black;
      h5 {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 37px;
          border-bottom: 2px solid black;
          @media (min-width: 992px) {
            top: 39px;
            border-bottom: 3px solid black;
          }
          left: 0;
          right: 0;
        }
      }
    }
  }
`;
